module.exports = __webpack_public_path__ + "static/media/digital.497d835b.jpg";